import { render, staticRenderFns } from "./ObjectChildren.vue?vue&type=template&id=32a76f33&scoped=true"
import script from "./ObjectChildren.vue?vue&type=script&lang=js"
export * from "./ObjectChildren.vue?vue&type=script&lang=js"
import style0 from "./ObjectChildren.vue?vue&type=style&index=0&id=32a76f33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a76f33",
  null
  
)

export default component.exports